var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-header',{staticClass:"user-header",staticStyle:{"background":"#fff","padding":"0"}},[_c('a',{staticClass:"logout",attrs:{"href":"#"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("登出")])])
}
var staticRenderFns = []

export { render, staticRenderFns }